module.exports = __webpack_public_path__ + "static/divas5s-067c8cca3227f7cb686bd13c39bc1ca9.jpg";